// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hr5F03zreqWWeMKZN2Rh [focus-within] input{border-color:var(--data-color)}.hr5F03zreqWWeMKZN2Rh :focus-within input{border-color:var(--data-color)}.hr5F03zreqWWeMKZN2Rh label{color:#000 !important;display:block !important;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\" !important;font-size:1rem !important;font-weight:600 !important;line-height:1.5;margin-top:1.5rem !important;padding-left:.25rem;text-align:left !important}._2QFhINb33hXE_Fi-ko656l{color:#dc3545;font-size:.75rem;margin-bottom:1rem}._3D7fYdkZ-U275TDPaIbCM0{right:0}", ""]);
// Exports
exports.locals = {
	"formArea": "hr5F03zreqWWeMKZN2Rh",
	"error": "_2QFhINb33hXE_Fi-ko656l",
	"right": "_3D7fYdkZ-U275TDPaIbCM0"
};
module.exports = exports;
